import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';
//验证手机号是否已经注册为工程师
export const engineerVerify = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer/verify?` + params,
        method: 'GET'
    })
}

//通过已注册手机号升级为监管
export const engineerUpgrade = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer/upgrade?` + params,
        method: 'POST',
    })
}

//降级工程监管为工程师(批量)
export const engineerDemotionUpgrade = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer/demotionUpgrade?` + params,
        method: 'POST',
    })
}




export const findBindEngineer = (params) => { //工程监理管理列表
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer?` + params,
        method: 'GET'
    })
}
export const findUserList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-basic/v1/user/findUserList?` + params,
        method: 'GET'
    })
}

export const addBindEngineer = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer`,
        method: 'POST',
        data: params
    })
}

export const delBindEngineer = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/engineer/${ids}`,
        method: 'DELETE',
    })
}